import axios from "axios";
import { baseURL } from "../Constants";

const url = `${baseURL}/ApiKeyAdmin`;

export interface ApiKey {
    id: number;
    keyPrefix: string;
    ownerName: string;
    ownerEmail: string | null;
    appName: string | null;
    rateTier: string;
    active: boolean;
    createdAt: string;
    revokedAt: string | null;
    lastUsedAt: string | null;
    totalRequests: number;
}

export interface CreatedApiKey {
    key: string; // plaintext, shown only once
    id: number;
    keyPrefix: string;
    ownerName: string;
    ownerEmail: string | null;
    appName: string | null;
    rateTier: string;
    createdAt: string;
}

export interface ApiKeyUsageRow {
    apiKeyId: number;
    usageDate: string;
    requestCount: number;
}

const authHeader = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getApiKeys = async (token: string): Promise<ApiKey[]> => {
    const response = await axios.get(`${url}/keys`, authHeader(token));
    return response.data;
};

export const createApiKey = async (
    payload: { ownerName: string; ownerEmail?: string; appName?: string; rateTier?: string },
    token: string
): Promise<CreatedApiKey> => {
    const response = await axios.post(`${url}/create`, payload, authHeader(token));
    return response.data;
};

export const revokeApiKey = async (id: number, token: string): Promise<void> => {
    await axios.post(`${url}/revoke/${id}`, {}, authHeader(token));
};

export const getApiKeyUsage = async (token: string, days = 30): Promise<ApiKeyUsageRow[]> => {
    const response = await axios.get(`${url}/usage?days=${days}`, authHeader(token));
    return response.data;
};
